import { Constants } from '@pwc/pwc-deals-web-common';
import { resetCalculationDataByDocumentCodesThunk } from './resetCalculationDataByDocumentCodesThunk';
import {
  transformAllIngestedDataThunk,
  transformAllIngestedDocumentsThunk,
} from './transformAllIngestedDataThunk';
import { resetStructuredAnalysis } from '../reducers/structuredAnalysisViewSlice';
import { resetStructuredDocumentDescription } from '../reducers/structuredDocumentDescriptionSlice';

export const clearDataAndtransformAllIngestedStructuredDocumentsThunk =
  (
    projectId,
    documentCodeForReview,
    isViewingAsClient = true,
    isEditMode = false
  ) =>
  (dispatch) => {
    const documentSetups = [
      {
        code: Constants.QUALITY_OF_EARNINGS,
        fetchLibraryItems: true,
      },
      {
        code: Constants.REPORTED_INCOME_STATEMENT,
        fetchLibraryItems: false,
      },
      {
        code: Constants.DEBT_AND_DEBT_LIKE,
        fetchLibraryItems: true,
      },
      {
        code: Constants.NET_WORKING_CAPITAL,
        fetchLibraryItems: true,
      },
      {
        code: Constants.BALANCE_SHEET,
        fetchLibraryItems: false,
      },
    ];

    dispatch(resetStructuredAnalysis());
    dispatch(resetStructuredDocumentDescription());

    dispatch(
      resetCalculationDataByDocumentCodesThunk(
        projectId,
        documentSetups.map((setup) => setup.code)
      )
    );

    dispatch(
      transformAllIngestedDataThunk(
        projectId,
        documentCodeForReview,
        isViewingAsClient,
        isEditMode
      )
    );
  };

export const clearDataAndTransformAllIngestedStructuredDocumentsThunk =
  (projectId, documentCodesForReview, isViewingAsClient = true) =>
  (dispatch) => {
    const documentSetups = [
      {
        code: Constants.QUALITY_OF_EARNINGS,
        fetchLibraryItems: true,
      },
      {
        code: Constants.REPORTED_INCOME_STATEMENT,
        fetchLibraryItems: false,
      },
      {
        code: Constants.DEBT_AND_DEBT_LIKE,
        fetchLibraryItems: true,
      },
      {
        code: Constants.NET_WORKING_CAPITAL,
        fetchLibraryItems: true,
      },
      {
        code: Constants.BALANCE_SHEET,
        fetchLibraryItems: false,
      },
    ];

    dispatch(
      resetCalculationDataByDocumentCodesThunk(
        projectId,
        documentSetups.map((setup) => setup.code)
      )
    );

    dispatch(
      transformAllIngestedDocumentsThunk(
        projectId,
        documentCodesForReview,
        isViewingAsClient
      )
    );
  };
